/**
 * useUpload — headless upload state for a single file slot.
 */
import { ref } from "vue";

export function useUpload(uploader, { kind = "file" } = {}) {
  const uploading = ref(false);
  const progress = ref(0);
  const error = ref("");
  const url = ref("");

  async function upload(file) {
    if (!file) return "";
    uploading.value = true;
    progress.value = 0;
    error.value = "";
    try {
      const hosted = await uploader(file, (p) => (progress.value = p));
      url.value = hosted ?? "";
      return url.value;
    } catch {
      error.value = `Couldn't upload the ${kind}. Please try again.`;
      throw new Error(error.value);
    } finally {
      uploading.value = false;
    }
  }

  function reset() {
    uploading.value = false;
    progress.value = 0;
    error.value = "";
    url.value = "";
  }

  return { uploading, progress, error, url, upload, reset };
}
